module.exports = __webpack_public_path__ + "static/media/youtube-white.c9c3f2c6.svg";